import React, { useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import { Select3 } from "@weezevent/nacre";
import { getCheckpoints, getEventConfigCheckpoints } from "../../../../api";
import { toArray } from "../../../../utils/filters";

const format = checkpoint => ({
	value: String(checkpoint.id),
	text: checkpoint.name
});

const CheckpointIdsFilter = ({
	value = [],
	onChange,
	initialCheckpoints = [],
	organizationId = null,
	eventId = null
}) => {
	const initialOptions = useMemo(
		() =>
			initialCheckpoints
				.map(format)
				.filter(checkpoint => checkpoint.text),
		[initialCheckpoints]
	);

	const onHandleSearch = useCallback(
		async searchString => {
			const query = searchString?.trim();
			if (!query) return { options: initialOptions };

			const params = {
				archived: false,
				search: query,
				...(eventId
					? { only_stats: true }
					: {
							with_event_config_checklists: false
					  })
			};

			const resp = eventId
				? await getEventConfigCheckpoints(
						organizationId,
						eventId,
						params
				  ).then(r => r.response)
				: await getCheckpoints(organizationId, params).then(
						response => response.data
				  );

			return {
				options: (resp || [])
					.map(format)
					.filter(checkpoint => checkpoint.text)
			};
		},
		[organizationId, eventId, initialOptions]
	);

	return (
		<Select3
			multiple
			value={toArray(value)
				.map(String)
				.filter(Boolean)}
			onChange={onChange}
			options={initialOptions}
			search={onHandleSearch}
		/>
	);
};

CheckpointIdsFilter.propTypes = {
	value: PropTypes.oneOfType([PropTypes.array, PropTypes.instanceOf(Set)]),
	onChange: PropTypes.func.isRequired,
	initialCheckpoints: PropTypes.array,
	organizationId: PropTypes.number,
	eventId: PropTypes.number
};

export default CheckpointIdsFilter;
